module.exports = __webpack_public_path__ + "media/frontend/assets/icons/icon-pass-bf267b79d41aef82f212fff5fb683fbc.png";